import { Routes } from '@angular/router';
import { VenueGuard } from './core/guards/venue.guard';

export const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		redirectTo: '',
	},
	{
		path: '',
		loadComponent: () => import('./shared/sub-features/feature-nav-bar/nav-bar.component').then(m => m.NavBarComponent),
		children: [
			{
				path: '',
				redirectTo: 'home',
				pathMatch: 'full',
			},
			{
				path: 'home',
				loadComponent: () => import('./domains/home/home.component').then(m => m.HomeComponent),
			},
			{
				path: 'map',
				loadComponent: () => import('./domains/maps/maps.component').then(m => m.MapsComponent),
			},
			{
				path: 'loyalty',
				loadComponent: () => import('./domains/loyalty/rewards.component').then(m => m.RewardsComponent),
			},
			{
				path: 'menu',
				loadComponent: () => import('./domains/menu/menu/menu.component').then(m => m.MenuComponent),
			},
			{
				path: 'cart',
				loadComponent: () =>
					import('./domains/menu/checkout-order/checkout-order.component').then(m => m.CheckoutOrderComponent),
			},
			{
				path: 'deals',
				loadComponent: () => import('./domains/deals/deals.component').then(m => m.DealsComponent),
			},
			{
				path: 'account',
				outlet: 'account',
				loadComponent: () =>
					import('./domains/account/account-layout/account-layout.component').then(m => m.AccountLayoutComponent),
				children: [
					{
						path: '',
						pathMatch: 'full',
						loadComponent: () => import('./domains/account/account.component').then(m => m.AccountComponent),
					},
					{
						path: 'profile',
						loadComponent: () =>
							import('./domains/account/features/profile/profile.component').then(m => m.ProfileComponent),
					},
					{
						path: 'addresses',
						loadComponent: () =>
							import('./domains/account/features/addresses/addresses.component').then(m => m.AddressesComponent),
					},
					{
						path: 'notifications',
						loadComponent: () =>
							import('./domains/account/features/notifications/notifications.component').then(
								m => m.NotificationsComponent
							),
					},
					{
						path: 'favorite-stores',
						loadComponent: () =>
							import('./domains/account/features/favorite-stores/favorite-stores.component').then(
								m => m.FavoriteStoresComponent
							),
					},
					{
						path: 'orders',
						loadComponent: () =>
							import('./domains/account/features/orders/orders.component').then(m => m.OrdersComponent),
					},
					{
						path: 'cards',
						loadComponent: () => import('./domains/account/features/cards/cards.component').then(m => m.CardsComponent),
					},
					{
						path: 'docs/:docType',
						loadComponent: () => import('./domains/docs/docs.component').then(m => m.DocsComponent),
					},
				],
			},
			{
				path: 'payment/success/:paymentId',
				loadComponent: () =>
					import('./domains/payment/payment-success/payment-success.component').then(m => m.PaymentSuccessComponent),
			},
			{
				path: 'payment/fail/:paymentId',
				redirectTo: '/cart',
			},
			{
				path: 'sign-in',
				loadComponent: () =>
					import('./domains/auth/email-action/email-action.component').then(m => m.EmailActionComponent),
			},
			{
				path: 'email-action',
				loadComponent: () =>
					import('./domains/auth/email-action/email-action.component').then(m => m.EmailActionComponent),
			},
		],
	},
	{
		path: '**',
		redirectTo: '',
	},
];
